import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import setTitle from '../utils/bridge/setTitle' // 改变标题
import serviceAPI from '../api/serviceAPI'

Vue.use(Router);

// 基础路由
function baseRouter() {
    const Login = () =>
        import ('@/views/login'); // 登录页
    const Self = () =>
        import ('@/views/self'); // 个人中心
    const Setting = () =>
        import ('@/views/setting'); // 完善信息
    const activityHome = () =>
        import ('@/views/activityHome'); // 首页  home ===> activityHome原首页设置为活动首页 2020、4、13
    const upload = () =>
        import ('@/views/upload'); // 首页
    const rules = () =>
        import ('@/views/rules'); // 首页
    const detail = () =>
        import ('@/views/detail'); // 首页

    //二期路由配置 
    const Home = () =>
        import ('@/views/home'); // 首页
    const Search = () =>
        import ('@/views/search'); // 搜索页
    const SearchResult = () =>
        import ('@/views/search/searchResult'); // 搜索页
    const MeetingDetail = () =>
        import ('@/views/detail/meetingDetail'); // 会议详情页
    const Discuss = () =>
        import ('@/views/discuss'); // 评论
    const ArticleDetail = () =>
        import ('@/views/detail/articleDetail'); // 文章详情
    const PptDetail = () =>
        import ('@/views/detail/pptDetail'); // 病例详情
    const Survey = () =>
        import ('@/views/detail/survey'); // 调研详情
    const Collection = () =>
        import ('@/views/collection'); // 收藏
    const RepresentCenter = () =>
        import ('@/views/self/representCenter'); // 收藏 
    const Poster = () =>
        import ('@/views/self/poster'); // 邀请海报 
    const Doctor = () =>
        import ('@/views/doctor/index'); // 邀请海报 
    const mySurvey = () =>
        import ('@/views/self/mySurvey'); // 邀请海报 


    // 基础router 
    const router = [{
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                title: '登录'
            }
        }, {
            path: '/self',
            name: 'self',
            component: Self,
            meta: {
                title: '个人中心',
                backIndex: true
            }
        }, {
            path: '/setting',
            name: 'setting',
            component: Setting,
            meta: {
                title: '完善信息'
            }
        }, {
            path: '/activityHome',
            name: 'activityHome',
            component: activityHome,
            meta: {
                title: '活动首页'
            }
        }, {
            path: '/upload',
            name: 'upload',
            component: upload,
            meta: {
                title: '征集',
                backActivity: true
            }
        }, {
            path: '/rules',
            name: 'rules',
            component: rules,
            meta: {
                title: '活动规则',
                backActivity: true,
                auth: true
            }
        }, {
            path: '/detail',
            name: 'detail',
            component: detail,
            meta: {
                title: '详情',
                backActivity: true,
                auth: true
            }
        },

        //二期路由 

        { // 首页
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                title: '随糖演义',
            }
        },
        { //搜索
            path: '/search',
            name: 'search',
            component: Search,
            meta: {
                title: '搜索',
                backIndex: true,
            }
        },
        { //会议详情页
            path: '/meetingDetail',
            name: 'meetingDetail',
            component: MeetingDetail,
            meta: {
                // title: '搜索',
                backIndex: true,
                backTop: true,
            }
        },

        { //发布评论
            path: '/discuss',
            name: 'discuss',
            component: Discuss,
            meta: {
                title: '发布评论',
            }
        },
        { //文章详情页
            path: '/articleDetail',
            name: 'articleDetail',
            component: ArticleDetail,
            meta: {
                // title: '搜索',
                backIndex: true,
                backTop: true,
            }
        },
        { //病例详情页
            path: '/pptDetail',
            name: 'pptDetail',
            component: PptDetail,
            meta: {
                // title: '搜索',
                backIndex: true,
                backTop: true,
            }
        },
        { //搜索結果
            path: '/searchResult',
            name: 'searchResult',
            component: SearchResult,
            meta: {
                // title: '搜索',
                backIndex: true,
                // backTop: true,
            }
        },
        { //调研详情
            path: '/survey',
            name: 'survey',
            component: Survey,
            meta: {
                // title: '搜索',
                backIndex: true,
                backTop: true,
            }
        },
        { //个人收藏
            path: '/collection',
            name: 'collection',
            component: Collection,
            meta: {
                title: '个人收藏',
                backIndex: true
            }
        },
        { //代表个人中心
            path: '/representCenter',
            name: 'representCenter',
            component: RepresentCenter,
            meta: {
                title: '个人中心',
                backIndex: true
            }
        },
        { //代表个人中心
            path: '/poster',
            name: 'poster',
            component: Poster,
            meta: {
                title: '邀请海报',
                // backHome: true
            }
        },
        { //代表个人中心  
            path: '/doctor',
            name: 'doctor',
            component: Doctor,
            meta: {
                title: '客户管理',
                backIndex: true
            }
        },
        { //我的调研 
            path: '/mySurvey',
            name: 'mySurvey',
            component: mySurvey,
            meta: {
                title: '我的调研',
                backIndex: true
            }
        },


    ];
    return router;
}

// router对象工厂 
function routerFactory() {
    const routers = baseRouter();

    const routerObj = new Router({
        routes: routers
    });
    // 全局router守卫
    routerObj.beforeEach(async(to, from, next) => {
        await store.dispatch('init');
        const encrypt = store.getters['user/encrypt'];
        // 如果query中存在inviteUid的场合，则记录inviteUid
        if (to.query && to.query.inviteUid) {
            store.commit('user/setinviteUid', to.query.inviteUid);
        }
        if (to.meta.auth) { // 已登录用户或者授权页面中跳转
            next();
            return;
        }
        if (!encrypt && to.name !== 'login') {
            // 设置来源路径
            if (to.name !== 'login' && to.name !== 'setting') {
                store.commit('setAuthorizeBeforePath', to.fullPath);
            }
            next({
                path: '/login',
                replace: true,
            });
            return;
        }
        const userInfo = store.getters['user/userInfo'] || {};
        const inviteUid = store.getters['user/inviteUid'];
        const uidStatus = store.getters['user/uidStatus'];
        console.log(userInfo.userType)
        if (encrypt && userInfo.type !== "A" && userInfo.userType === "A" && to.name !== 'setting') {
            next({
                path: '/setting',
                replace: true,
            });
            return;
        }
        if (to.path === '/' && !to.query.modelCode) {
            next({
                path: '/',
                query: { modelCode: 'STYY-SQBK' }
            })
            return;
        }
        if (encrypt && uidStatus && inviteUid && userInfo.type !== 'A') {
            await serviceAPI.inviteUidCheck({});
            // store.commit('user/setinviteUid', null)
            store.dispatch('user/setUidStatus', false)
        }

        // 设置页面标题
        if (to.meta.title) {
            setTitle(to.meta.title);
        }
        next();
    });

    routerObj.onReady(() => {});

    return routerObj;
}

export default routerFactory();


// WEBPACK FOOTER //
// ./src/router/index.js